/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
  deleteCall,
} from "../../../config";
import Pagination from "../../../components/Pagination";
import { formatNumber } from "../../../lib/Misc";
import MainBody from "../../../components/MainBody/MainBody";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Confirmation from "../../../components/Confirmation";
import moment from "moment";

// Here id => VenderId
const BankTransactionByBatch = ({ id = "", expandList = false }) => {
  const navigate = useNavigate();

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [loading, setLoading] = useState(false);
  const [bankTransactionData, setBankTransactionData] = useState([]);
  const [page, setPage] = useState(expandList ? 1 : defaultPage || 1);
  const [limit, setLimit] = useState(
    expandList ? defaultLimitPagination : defaultLimit || defaultLimitPagination
  );
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();

  const [transactionId, setTransactionId] = useState(null);

  const [showDelete, setShowDelete] = React.useState(false);

  const toggleShowDelete = () => {
    if (showDelete) {
      setTransactionId(null);
    }
    setShowDelete(!showDelete);
  };

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  const fetchBankTransactionsByBatch = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.BANK_TRANSACTION_BY_BATCHES}/` +
            id +
            `?limit=${
              passLimit ? passLimit : limit ? limit : defaultLimitPagination
            }&page=${passPage ? passPage : page ? page : 1}`
        );
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        setBankTransactionData(data?.data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setBankTransactionData([]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id]
  );

  // *API Call for Geting Assets - End

  const bankTransactionGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: bankTransactionData[i]?.id,
        date: bankTransactionData[i]?.transaction_date
          ? moment(
              bankTransactionData[i]?.transaction_date,
              "DD-MM-YYYY"
            ).format("DD-MM-YYYY")
          : "-",
        project_name: bankTransactionData[i]?.builder_project?.project_name
          ? bankTransactionData[i]?.builder_project?.project_name
          : "-",
        description: bankTransactionData[i]?.description
          ? bankTransactionData[i]?.description
          : "-",
        credit:
          bankTransactionData[i]?.base_type === 1 ? (
            <span className="rag-green">
              {"$" + formatNumber(Number(bankTransactionData[i]?.amount))}
            </span>
          ) : (
            "-"
          ),
        debit:
          bankTransactionData[i]?.base_type === 0 ? (
            <span className="rag-red">
              {"$" + formatNumber(Number(bankTransactionData[i]?.amount))}
            </span>
          ) : (
            "-"
          ),
        bank_transaction_source: bankTransactionData[i]?.source
          ? bankTransactionData[i]?.source
          : "-",
        action: bankTransactionData[i]?.deleted_at ? (
          ""
        ) : bankTransactionData[i]?.bank_reconciled_status !== 1 ? (
          <span className="flex items-center gap-2 justify-center">
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  onClick={() => {
                    setTransactionId(bankTransactionData[i]?.id);
                    toggleShowDelete();
                  }}
                  icon={faTrash}
                  size="1x"
                  data-toggle="modal"
                  data-target="#clientDetail"
                />
              </span>
            </CustomTooltip>
          </span>
        ) : (
          <></>
        ),
        archived: bankTransactionData[i]?.deleted_at ? (
          <div style={{ textAlign: "center" }}>
            <CustomTooltip message={"Archived"}>
              <span>
                <span color={"red"} key={"red"}>
                  {String.fromCodePoint("0x0001F6AB")}
                </span>
              </span>
            </CustomTooltip>
          </div>
        ) : (
          ""
        ),
      });
    }
    return items;
  };

  const bankTransaction = bankTransactionGenerator(bankTransactionData?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "date",
      text: "Date",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "description",
      text: "Description",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "credit",
      text: "Credit",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "debit",
      text: "Debit",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "bank_transaction_source",
      text: "Bank Transaction Source	",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px", textAlign: "center" },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "archived",
      text: "",
      style: { textAlign: "center" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  useEffect(() => {
    fetchBankTransactionsByBatch();
  }, [fetchBankTransactionsByBatch]);

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchBankTransactionsByBatch(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchBankTransactionsByBatch(limit, page);
  };
  // *Assets Table Row and Column Generation, Filtering and Sorting of Record - End

  useEffect(() => {
    if (!expandList) {
      navigate(
        `/assets?limit=${limit ? limit : defaultLimitPagination}&page=${
          page ? page : 1
        }&sort_column=${sortField ? sortField : ""}&sort_order=${
          sortOrder ? sortOrder : ""
        }`,
        {
          replace: true,
        }
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, sortField, sortOrder, expandList]);

  const handleBankTransactionDelete = async () => {
    try {
      setLoading(true);
      await deleteCall(`${API.TRANSACTION_DELETE}/${transactionId}`);
      setLoading(false);
      fetchBankTransactionsByBatch();
      toggleShowDelete();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  return (
    <>
      <MainBody
        search={false}
        expandList={expandList}
        innerBody={true}
        actionContent={""}
        loading={loading}
      >
        <div className="custom-table">
          <div className={"table-body-class"}>
            <BootstrapTable
              keyField="asset_id"
              remote
              data={bankTransaction}
              columns={columns}
              onTableChange={handleTableChange}
              rowClasses={TRClasses}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
          {showDelete && (
            <Confirmation
              title={"Delete Bank Transaction"}
              open={showDelete}
              setOpen={setShowDelete}
              toggleShow={() => {
                toggleShowDelete();
              }}
              popupType={"bank-transactions"}
              className="sm:max-w-fit"
              message={`Are your sure you want to delete this bank transaction?`}
              okAction={async () => {
                await handleBankTransactionDelete();
              }}
              loading={loading}
              cancelAction={() => {
                toggleShowDelete();
              }}
            />
          )}
        </div>
      </MainBody>
    </>
  );
};
export default BankTransactionByBatch;
